/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useProductos } from "../../../../contexto/provider/ProductosContext.js";
import { useCategorias } from "../../../../contexto/provider/CategoriasContext.js";
import { useProductosBom } from "../../../../contexto/provider/ProductosBomContext.js";

import "./formCreacion.css";

export default function CrearProductoForm() {
  const { agregarProducto } = useProductos();
  const { categorias, cargarCategorias, cargando } = useCategorias();
  const { agregarProductoBom } = useProductosBom();

  const [codigoCreado, setCodigoCreado] = useState(null);

  const [form, setForm] = useState({
    nombre: "",
    precio_unitario: "",
    costo_unitario: "",
    Clase: "",
    categoria: "",
    estado: "True",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const resultado = await agregarProducto({
        ...form,
        precio_unitario: Number(form.precio_unitario),
        costo_unitario: Number(form.costo_unitario),
      });

      if (!resultado.success) {
        setError(resultado.error);
        return;
      }

      const productoCreado = resultado.data[0];

      //  Si es línea, crear BOM automáticamente (silencioso)
      if (form.Clase?.trim().toLowerCase() === "linea") {
        await agregarProductoBom({
          producto_linea: productoCreado.Codigo,
          producto_insumo: productoCreado.Codigo, // ejemplo base
          cantidad: 1,
          unidad: "UND",
          usuario: "system",
        });
      }

      setCodigoCreado(productoCreado.Codigo);
      setSuccess(true);

      setForm({
        nombre: "",
        precio_unitario: "",
        costo_unitario: "",
        Clase: "",
        categoria: "",
        estado: "True",
      });
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    cargarCategorias();
  }, []);

  return (
 <form className="form-card" onSubmit={handleSubmit}>
  <h2 className="form-title">Crear Producto</h2>

  {/* Fila 1: Nombre y Clase */}
  <div className="form-group-row">
    <div className="form-group">
      <label htmlFor="nombre" className="form-label">Nombre</label>
      <input
        id="nombre"
        name="nombre"
        placeholder="Nombre"
        value={form.nombre}
        onChange={handleChange}
        className="form-input"
        required
      />
    </div>

    <div className="form-group">
      <label htmlFor="Clase" className="form-label">Clase</label>
      <select
        id="Clase"
        name="Clase"
        value={form.Clase}
        onChange={handleChange}
        className="form-input"
        required
      >
        <option value="">Seleccione Clase</option>
        <option value="linea">Linea</option>
        <option value="insumo">Insumo</option>
      </select>
    </div>
  </div>

  {/* Fila 2: Precio y Costo */}
  <div className="form-group-row">
    <div className="form-group">
      <label htmlFor="precio_unitario" className="form-label">Precio Unitario</label>
      <input
        id="precio_unitario"
        name="precio_unitario"
        type="number"
        placeholder="Precio"
        value={form.precio_unitario}
        onChange={handleChange}
        className="form-input"
        required
      />
    </div>

    <div className="form-group">
      <label htmlFor="costo_unitario" className="form-label">Costo Unitario</label>
      <input
        id="costo_unitario"
        name="costo_unitario"
        type="number"
        placeholder="Costo"
        value={form.costo_unitario}
        onChange={handleChange}
        className="form-input"
      />
    </div>
  </div>

  {/* Fila 3: Categoría y Estado */}
  <div className="form-group-row">
    <div className="form-group">
      <label htmlFor="categoria" className="form-label">Categoría</label>
      <select
        id="categoria"
        name="categoria"
        value={form.categoria}
        onChange={handleChange}
        className="form-input"
        required
      >
        <option value="">Seleccione Categoría</option>
        {cargando && <option>Cargando...</option>}
        {!cargando &&
          categorias.map((cat) => (
            <option key={cat.id} value={cat.nombre}>
              {cat.nombre}
            </option>
          ))}
      </select>
    </div>

    <div className="form-group">
      <label htmlFor="estado" className="form-label">Estado</label>
      <select
        id="estado"
        name="estado"
        value={form.estado}
        onChange={handleChange}
        className="form-input"
      >
        <option value="True">Activo</option>
        <option value="False">Inactivo</option>
      </select>
    </div>
  </div>

  {/* Botón de submit */}
  <button type="submit" className="btn-android w-100" disabled={loading}>
    {loading ? "Creando..." : "Crear Producto"}
  </button>

  {/* Mensajes de error o éxito */}
  {error && <p className="form-msg error">{error}</p>}
  {success && (
    <p className="form-msg success">
      Producto creado correctamente. Código: {codigoCreado}
    </p>
  )}
</form>
  );
}
